module.exports = __webpack_public_path__ + "static/media/ic_favorite.d9afbc22.svg";